// Services.jsx
import { motion } from 'framer-motion';
import { FaTruckMoving, FaBoxes, FaHardHat, FaRoute, FaWarehouse } from 'react-icons/fa';
import { GiTruck, GiFactory, GiStonePile } from 'react-icons/gi';
import { SERVICES } from '../../data/siteData';
import './Services.css';

const ICONS = {
  GiTruck, FaTruckMoving, FaBoxes, GiFactory, FaHardHat, GiStonePile, FaRoute, FaWarehouse,
};

export default function Services({ compact = false }) {
  const list = compact ? SERVICES.slice(0, 6) : SERVICES;

  return (
    <section className={`section services ${compact ? '' : 'section-alt'}`} id="services">
      <div className="container">
        <div className="services__head">
          <p className="eyebrow">What We Move</p>
          <h2 className="section-title">Our Transport Services</h2>
        </div>

        <div className="services__grid">
          {list.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                className="service-card"
                key={s.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.1 }}
                whileHover={{ y: -10 }}
              >
                <div className="service-card__silhouette">
                  <FaTruckMoving />
                </div>
                <div className="service-card__icon">{Icon && <Icon />}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}